/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_Processing_Item_JobInputs */

const en_privacy_data_processing_item_job = /** @type {(inputs: Privacy_Data_Processing_Item_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job application data:`)
};

const de_privacy_data_processing_item_job = /** @type {(inputs: Privacy_Data_Processing_Item_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungsdaten:`)
};

const fr_privacy_data_processing_item_job = /** @type {(inputs: Privacy_Data_Processing_Item_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données de candidature :`)
};

const es_privacy_data_processing_item_job = /** @type {(inputs: Privacy_Data_Processing_Item_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos de solicitud de empleo:`)
};

const it_privacy_data_processing_item_job = /** @type {(inputs: Privacy_Data_Processing_Item_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati sulla candidatura:`)
};

const nl_privacy_data_processing_item_job = /** @type {(inputs: Privacy_Data_Processing_Item_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatiegegevens:`)
};

const pl_privacy_data_processing_item_job = /** @type {(inputs: Privacy_Data_Processing_Item_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane aplikacji o pracę:`)
};

const fi_privacy_data_processing_item_job = /** @type {(inputs: Privacy_Data_Processing_Item_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työhakemustiedot:`)
};

const da_privacy_data_processing_item_job = /** @type {(inputs: Privacy_Data_Processing_Item_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobansøgningsdata:`)
};

const sv_privacy_data_processing_item_job = /** @type {(inputs: Privacy_Data_Processing_Item_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobbansökningsdata:`)
};

/**
* | output |
* | --- |
* | "Job application data:" |
*
* @param {Privacy_Data_Processing_Item_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_data_processing_item_job = /** @type {((inputs?: Privacy_Data_Processing_Item_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_Processing_Item_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_data_processing_item_job(inputs)
	if (locale === "fr") return fr_privacy_data_processing_item_job(inputs)
	if (locale === "es") return es_privacy_data_processing_item_job(inputs)
	if (locale === "it") return it_privacy_data_processing_item_job(inputs)
	if (locale === "nl") return nl_privacy_data_processing_item_job(inputs)
	if (locale === "pl") return pl_privacy_data_processing_item_job(inputs)
	if (locale === "fi") return fi_privacy_data_processing_item_job(inputs)
	if (locale === "da") return da_privacy_data_processing_item_job(inputs)
	if (locale === "sv") return sv_privacy_data_processing_item_job(inputs)
	return en_privacy_data_processing_item_job(inputs)
});